import React from "react";
import "./Contact.css";
import SponsoredSlot from "../Sponsored/SponsoredSlot";

function Contact() {
  const instagramHandle = "kazhavda.mk";
  const email = "info@kazhavda.mk";

  return (
    <div className="contact-page">
      <div className="contact-sponsored-wrap">
        <SponsoredSlot placement="contact.top" />
      </div>
      <div className="contact-container">
        <div className="contact-card">
          <h2 className="contact-title">Контактирај нѐ</h2>
          <p className="contact-subtitle">
            Пронајди нѐ на социјалните мрежи
          </p>

          <div className="contact-info">
            <a
              href={`https://instagram.com/${instagramHandle}`}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
                alt="Instagram"
                className="contact-icon"
              />
              <span>@{instagramHandle}</span>
            </a>

            <a href={`mailto:${email}`} className="contact-link">
              <img
                src="https://cdn-icons-png.flaticon.com/512/732/732200.png"
                alt="Email"
                className="contact-icon"
              />
              <span>{email}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
